import React from "react";

export default function Container(props) {
  const pt = props.pt === undefined ? "pt-0" : props.pt;
  return <div className={`${pt} mx-auto lg:max-w-7xl`}>{props.children}</div>;
}
